const LOCAL_API_FALLBACK = 'http://localhost:4000';
const PROD_API_FALLBACK = 'https://server.pickaxetrader.com';

function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function pickFirstUrl(...candidates: Array<string | undefined | null>) {
  for (const candidate of candidates) {
    const trimmed = String(candidate || '').trim();
    if (trimmed) return trimTrailingSlash(trimmed);
  }
  return null;
}

function isLocalBrowserOrigin() {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

function getSafeFallbackBaseUrl() {
  if (isLocalBrowserOrigin()) {
    return (window as any).__LOCAL_API_FALLBACK__ || LOCAL_API_FALLBACK;
  }

  return PROD_API_FALLBACK;
}

export function getApiBaseUrl() {
  return (
    pickFirstUrl(
      import.meta.env.VITE_API_BASE_URL,
      import.meta.env.VITE_BACKEND_URL,
      (window as any).__API_BASE_URL__,
      (window as any).__BACKEND_URL__,
    ) || getSafeFallbackBaseUrl()
  );
}

export function getWsBaseUrl() {
  return (
    pickFirstUrl(
      import.meta.env.VITE_WS_URL,
      import.meta.env.VITE_API_BASE_URL,
      import.meta.env.VITE_BACKEND_URL,
      (window as any).__WS_URL__,
      (window as any).__API_BASE_URL__,
      (window as any).__BACKEND_URL__,
    ) || getSafeFallbackBaseUrl()
  );
}
